import React from 'react';

type Props = {
	step: number | string;
	className?: string;
};

export const StepNumber: React.FC<Props> = ({ step, className = "" }) => {
	return (
		<div
			className={`w-[30px] h-[30px] justify-center items-center rounded-[50%] flex-shrink-0 flex ${className}`}
			style={{
				background: 'linear-gradient(135deg, #1DBD4F 0%, #69B043 100%)'
			}}
		>
			<div className="text-[13px] text-white font-normal font-roboto justify-center items-center flex">
				{step}
			</div>
		</div>
	);
};

export default StepNumber;
